import types from "./types";
import * as logger from "@/helpers/logger";

export default {
  [types.TOGGLE_VIEW]: function({ commit }) {
    logger.log(commit);
  },

  updateScheme(context, scheme = {}) {
    const data = scheme.status ? scheme.data[0].value : scheme;
    let payload = {};

    Object.entries(data)
      .filter(([key]) => {
        if (key === "id") return false;
        return true;
      })
      .forEach(([key, value]) => {
        payload[key] = value;
      });

    context.commit(types.SET_APP_SCHEME, payload);
    return payload;
  },

  updateLogo(context, logo) {
    context.commit("updateLogo", logo);
  }
};
